import {
  type NewsletterAgreementValues,
  newsletterAgreementValues,
  type PhoneContactAgreementValues,
  phoneContactAgreementValues,
} from "apps/visits/packages/shared/modules/synerise/forms/shared";
import type { SnakeCase } from "type-fest";
import * as yup from "yup";
import { formTypeFactory } from "../synerise";

type InferredRegistrationFormSchema = yup.InferType<typeof registrationFormSchema>;
type RegistrationFormData = Omit<InferredRegistrationFormSchema, "city" | "isB2b"> & {
  city?: InferredRegistrationFormSchema["city"];
  isB2b?: InferredRegistrationFormSchema["isB2b"];
};

const registrationFormSchema = yup.object({
  email: yup.string().email().required(),
  phone: yup.string().required(),
  firstname: yup.string().min(3).required(),
  lastname: yup.string().min(3).required(),
  // Zgody opcjonalne: brak zgody = brak pola w payloadzie (PTS-287), patrz `grantedAgreement`.
  newsletterAgreement: yup
    .mixed<NewsletterAgreementValues>()
    .oneOf([...newsletterAgreementValues])
    .optional(),
  phoneContactAgreement: yup
    .mixed<PhoneContactAgreementValues>()
    .oneOf([...phoneContactAgreementValues])
    .optional(),
  city: yup.string().optional(),
  isB2b: yup.boolean().optional(),
});

/*
 * Tricky solution for set attribute [`city`, `isB2b`] not required
 * */
const registrationFormSchemaWithoutOptionalFields = registrationFormSchema.omit(["city", "isB2b"]);

export const registrationFormFactory = <Type extends string>(formType: SnakeCase<Type>, data: RegistrationFormData) =>
  formTypeFactory<Type, typeof registrationFormSchemaWithoutOptionalFields>(formType, registrationFormSchema)(data);
